import { FAVORITE_DELIVERY_TYPE } from 'common/constants';
import { getDeliveryAddress } from 'common/utils/favorite-address';
import { TFunction } from 'i18next';
import { CheckoutAddress, CheckoutInfo, FavoriteDeliveryType } from 'types/checkout-info';
import { FavoriteAddressDetails } from 'types/favorite-address';

export type AddressSheetItemType = FavoriteDeliveryType;

export type AddressSheetItemDisplay = {
  primary: string;
  secondary?: string;
};

const formatFloorFlat = (address: CheckoutAddress, t: TFunction): string | undefined => {
  const parts = [
    address.floor
      ? t('header.main.favorite-address.address-menu.address.floor', { floor: address.floor })
      : '',
    address.flat ? t('header.main.favorite-address.address-menu.address.flat', { flat: address.flat }) : '',
    address.city,
  ].filter(Boolean);

  return parts.length > 0 ? parts.join(', ') : undefined;
};

export const getAddressSheetItemDisplay = (
  type: AddressSheetItemType,
  t: TFunction,
  checkoutInfo: CheckoutInfo | null,
  regionName?: string,
  address?: FavoriteAddressDetails,
): AddressSheetItemDisplay | null => {
  switch (type) {
    case FAVORITE_DELIVERY_TYPE.REGION:
      return regionName ? { primary: regionName } : null;

    case FAVORITE_DELIVERY_TYPE.HOME_DELIVERY: {
      const primary = getDeliveryAddress(FAVORITE_DELIVERY_TYPE.HOME_DELIVERY, null, checkoutInfo);

      if (!primary || !checkoutInfo?.address) return null;

      return { primary, secondary: formatFloorFlat(checkoutInfo.address, t) };
    }

    case FAVORITE_DELIVERY_TYPE.PICKUP:
      return address?.storeName ? { primary: address.storeName, secondary: address.storeAddress } : null;

    case FAVORITE_DELIVERY_TYPE.PICKUP_POINT:
      return address?.pickupPointAddress
        ? { primary: address.pickupPointAddress, secondary: regionName }
        : null;
  }
};
